export default __webpack_public_path__ + "static/media/topic900_tip.8cf7b8a5.svg";